import { storageFactory } from "storage-factory";
const cookieToken = require("./cookie-token");

const storage = storageFactory(() => localStorage);

const AccountTokenStoragePort = {
  getItem: function (key) {
    const cookieValue = cookieToken.get();
    if (cookieValue !== undefined) {
      return cookieValue;
    }

    const value = storage.getItem(key);
    return value;
  },

  add: (app) => {
    app.ports.setTokenPort.subscribe((object) => {
      cookieToken.set(object.value);
      storage.setItem(object.key, object.value);
    });

    app.ports.removeTokenPort.subscribe((object) => {
      cookieToken.remove();
      storage.removeItem(object.key);
      app.ports.accountTokenRemovedPort.send(null);
    });

    window.addEventListener("storage", function (event) {
      if (event.key === "accountToken" && event.newValue === null) {
        app.ports.accountTokenRemovedPort.send(null);
      }
    });
  },
};

module.exports = AccountTokenStoragePort;
